<!--An item in the EventListing representing a given Event.
-->

<template>
  <mdb-row>
    <div v-if="loading" class="w-100 position-absolute">
      <mdb-spinner />
    </div>
    <div
      v-if="!loading && posts && posts.length > 0"
      class="w-100 animated bounce"
    >
      <div v-for="post in posts" :key="post.id">
        <mdb-row class="mb-5 mt-3">
          <mdb-col md="5">
            <mdb-view class="rounded z-depth-2 mb-lg-0 mb-4" hover>
              <img
                class="img-fluid"
                :src="`${post.intro_image.url}`"
                alt="Sample image"
              />
              <a>
                <mdb-mask overlay="white-slight" waves />
              </a>
            </mdb-view>
          </mdb-col>
          <mdb-col md="7">
            <!-- {{checkEvent(post.start_date)}}
            <div class="red" style="border-radius: 10px;" v-if="event_past">
              <p class="text-white"><strong>This event has already occurred.</strong></p>
            </div>
            <div class="green" style="border-radius: 10px;" v-if="event_today">
              <p class="text-white"><strong>This event is happening today!</strong></p>
            </div>   -->

            <h3 class="font-weight-bold mb-3 p-0">
              <strong>{{ post.title }}</strong>
            </h3>
            <p>{{ post.description }}</p>

            <!--If any date(s) given, show them-->

            <p v-if="post.start_date && post.end_date">
              <strong>Dates: </strong>{{ toDateString(post.start_date) }} -
              {{ toDateString(post.end_date) }}
            </p>
            <p v-else-if="post.start_date && !post.end_date">
              <strong>Date: </strong>{{ toDateString(post.start_date) }}
            </p>

            <!--If any time(s) given, show them-->

            <p v-if="post.start_time && post.end_time">
              <strong>Times: </strong>{{ toTimeString(post.start_time) }} -
              {{ toTimeString(post.end_time) }}
            </p>
            <p v-else-if="post.start_time && !post.end_time">
              <strong>Time: </strong>{{ toTimeString(post.start_time) }}; this
              event has no specified end time.
            </p>

            <!--If any venue is given, show it-->

            <p v-if="post.venue"><strong>Location: </strong>{{ post.venue }}</p>

            <!--Link to event info-->

            <router-link
              class="menu-item pl-0"
              :to="'/event/' + post.meta.slug"
            >
              <mdb-btn color="primary" class="waves-light" size="sm"
                >Read More</mdb-btn
              >
            </router-link>
          </mdb-col>
        </mdb-row>
        <hr class="mb-5" />
      </div>
    </div>
    <div
      v-else-if="!loading && posts && posts.length == 0"
      class="w-100 animated bounce"
    >
      <h2 class="h1-responsive font-weight-bold text-center my-5">
        No Events Found
      </h2>
    </div>
  </mdb-row>
</template>

<script>
import { mdbRow, mdbCol, mdbMask, mdbView, mdbBtn, mdbSpinner } from "mdbvue";
import axios from "axios";
import api from "@/api";
import shared from "@/shared";
import _ from "lodash";

export default {
  name: "EventPosts",
  components: {
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBtn,
    mdbSpinner,
  },
  props: {
    slug: {
      type: [String],
    },
    type: {
      type: [String],
      default: "events.Event",
    },
    descendant_of: {
      type: [Number, Boolean],
    },
    fields: {
      type: [String],
      default: "*",
    },
    search: {
      type: [String],
    },
    offset: {
      type: [Number],
      default: 0, //Maybe the default of 0 is causing trouble?
    },
  },
  data() {
    return {
      loading: true,
      posts: false,
      event_today: false,
      event_past: false,
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.getDataDebounced = _.debounce(this.getData, 500);
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      if (this.descendant_of) {
        params.append("descendant_of", this.descendant_of);
      }
      params.append("type", this.type);
      params.append("fields", this.fields);
      if (this.search) {
        params.append("search", this.search);
      }
      params.append("order", "-start_date");
      params.append("limit", "10");
      params.append("offset", this.offset);

      return params;
    },
  },
  methods: {
    getData() {
      this.loading = true;
      axios;
      api
        .get("pages/", {
          params: this.axiosParams,
        })
        .then((response) => {
          this.posts = response.data.items;
          var count = response.data.meta.total_count;
          this.$emit("setUpPagination", count);
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    },
    toDateString: function (date) {
      var new_date = shared.getDate(date);
      return new_date.toLocaleDateString();
    },
    toTimeString: function (time) {
      return shared.TwelveHrTime(time);
    },
    // checkEvent(event_date) {
    //   var today = new Date();
    //   var event = new Date(event_date);
    //   if (event.getFullYear() >= today.getFullYear()) {
    //     if (event.getMonth() >= today.getMonth()) {
    //       if (event.getDate() == today.getDate()) {
    //         this.event_today = true;
    //       }
    //       else if (event.getDate() < today.getDate()) {
    //         this.event_past = true;
    //       }
    //     }
    //   }
    // }
  },
  watch: {
    descendant_of: function () {
      this.getData();
    },
    search: function () {
      this.getDataDebounced();
    },
    posts: function () {
      this.loading = true;
      process.nextTick(
        function () {
          this.loading = false;
        }.bind(this)
      );
    },
    offset: function () {
      this.getData();
    },
  },
};
</script>